// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from TabBar-ButtonIcon.module.scss  */
.TabBar-ButtonIcon-module-Root_18e {
  display: flex;
  margin: 7px;
  place-items: center;
  place-content: center; }
  .TabBar-ButtonIcon-module-Root_18e path {
    fill: var(--tab-bar-text-color); }

.TabBar-ButtonIcon-module-ButtonIconActive_2lJ path {
  fill: var(--tab-bar-active-text-color); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/TabBar/ButtonIcon/TabBar-ButtonIcon.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,qBAAqB,EAAE;EACvB;IACE,+BAA+B,EAAE;;AAErC;EACE,sCAAsC,EAAE","sourcesContent":["/*  imported from TabBar-ButtonIcon.module.scss  */\n.TabBar-ButtonIcon-module-Root_18e {\n  display: flex;\n  margin: 7px;\n  place-items: center;\n  place-content: center; }\n  .TabBar-ButtonIcon-module-Root_18e path {\n    fill: var(--tab-bar-text-color); }\n\n.TabBar-ButtonIcon-module-ButtonIconActive_2lJ path {\n  fill: var(--tab-bar-active-text-color); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
